import { useQuery } from "react-query";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { KandidatResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllKandidatKey = "all-kandidat-key";

export async function fetchAllKandidat(): Promise<KandidatResponse[]> {
  const res = await ApiClient.get(`/AllKandidat`);
  return res.data;
}

export default function useFetchAllKandidat() {
  return useQuery([fetchAllKandidatKey], queryWrapper(fetchAllKandidat));
}
